module.exports = __webpack_public_path__ + "static/uitm-601c398feabf4e10b00b05916b62d1b4.png";